import * as angular from 'angular';
import * as _ from 'lodash';

import { ILogService } from '../../services/data';
import { Log } from '../../models/Log';
import { ComponentDefinition } from '../../models';

class TaskLogsController implements angular.IComponentController {
    static controllerId: string = 'taskLogs';
    logs: Log[];
    private _logs: Log[];
    taskGuid: string;
    isLoading: boolean;
    pageNumber: number;
    pageCount: number;
    pageSize: number;
    total: number;
    static $inject = ['logService'];

    constructor(private _logService: ILogService) {
    }

    $onInit() {
        this.pageNumber = 0;
        this.pageCount = 0;
        this.pageSize = 25;
        if (this.taskGuid) {
            this.loadLogs();
        }
    }

    loadLogs() {
        this.isLoading = true;
        this._logService.getAllAPI(true) //prev.toISOString(), now.toISOString())
            .then((data) => {
                this._logs = _.sortBy(data.filter(d => d.user === this.taskGuid), d => d.timestamp).reverse(); //.slice(0, 50);
                this.pageNumber = 0;
                this.total = this._logs.length;
                this.pageCount = Math.ceil(this._logs.length / this.pageSize);
                this.logs = this._logs.slice(this.pageNumber * this.pageSize, this.pageSize);
            })
            .finally(() => this.isLoading = false);
    }

    previous() {
        if (this.pageNumber) {
            this.pageNumber--;
            this.refresh();
        }
    }

    next() {
        if (this.pageNumber < this.pageCount) {
            this.pageNumber++;
            this.refresh();
        }
    }

    private refresh() {
        const start = this.pageNumber * this.pageSize;
        this.logs = this._logs.slice(start, start + this.pageSize);

    }
}

export const wtTaskLogs: ComponentDefinition = {
    componentId: 'wtTaskLogs',
    controller: TaskLogsController,
    template: require('./taskLogs.component.html'),
    controllerAs: 'vm',
    bindings: {
        taskGuid: '<',
        task: '<?'
    }
};
